/**
 * The component list.
 *
 * `add` is called from inside the render passes, so the list always equals what
 * is actually drawn: split planks count as their nearest real ALP length,
 * omitted guardrails are not counted, handrails follow the chosen side.
 */

export const GROUP_ORDER: readonly string[] = [
  "Base",
  "Standards",
  "Beams",
  "Brackets",
  "Decking",
  "Access",
  "Guardrails",
  "Toe boards",
  "Bracing",
];

export type BomRow = Readonly<{
  group: string;
  name: string;
  art: string;
  kg: number;
  n: number;
}>;

export class BomCollector {
  private readonly rows = new Map<
    string,
    { group: string; name: string; art: string; kg: number; n: number }
  >();

  add(group: string, name: string, art: string, kg: number, n = 1): void {
    const key = `${group}|${name}`;
    const existing = this.rows.get(key);
    if (existing) {
      existing.n += n;
      return;
    }

    this.rows.set(key, { group, name, art, kg, n });
  }

  /** Rows grouped in `GROUP_ORDER`, alphabetical within each group. */
  result(): { rows: BomRow[]; totalKg: number } {
    const rows: BomRow[] = [];
    let totalKg = 0;

    for (const group of GROUP_ORDER) {
      const inGroup = [...this.rows.values()]
        .filter((row) => row.group === group)
        .sort((a, b) => a.name.localeCompare(b.name, "en"));

      for (const row of inGroup) {
        totalKg += row.kg * row.n;
        rows.push({ ...row });
      }
    }

    return { rows, totalKg };
  }
}
